import {translate} from "../../../../../components/translate/translate.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";

export const GARRISON_FISCALIZATION_FIELD = "Fiscalizar a guarnição";
const IGNORED_INLINE_FIELDS = ["dispatch_displacement", "image-reservation", GARRISON_FISCALIZATION_FIELD];
const ATTACHMENT_FIELD = "dispatch_attachment";

const hasValue = (value) => value !== null && value !== undefined && value !== "";

const formatBoolean = (value) => typeof value === "boolean" ? (value ? "Sim" : "Não") : value;

const formatGarrisonStatus = (value) => {
    if (value === true) return "Em andamento";
    if (value === false) return "Encerrado";
    return value;
};

const formatCompositionType = (type) => ({
    WITH_VEHICLE: "Com veículo",
    WITHOUT_VEHICLE: "A pé"
}[type] ?? translate(type));

const formatIntegrants = (integrants) => {
    if (!integrants) return "";

    const list = Array.isArray(integrants) ? integrants : Object.values(integrants);
    return list.map(integrant => {
        const contingent = integrant?.contingent ?? integrant?.contingent_id;
        const name = contingent?.namewar ?? contingent?.name ?? integrant?.namewar ?? integrant?.name;
        return [name, integrant?.position].filter(Boolean).join(" - ");
    }).filter(Boolean).join(", ");
};

const buildCompositionRows = (composition) => {
    if (!composition) return [];

    const list = Array.isArray(composition) ? composition : Object.values(composition);
    return list.flatMap((item, index) => {
        const integrants = formatIntegrants(item?.compositiongarrison_integrants);
        const suffix = list.length > 1 ? ` ${index + 1}` : "";

        return [
            {label: `Composição${suffix}`, value: item?.compositiongarrison_name},
            {label: `Tipo da composição${suffix}`, value: item?.compositiongarrison_type ? formatCompositionType(item.compositiongarrison_type) : null},
            {label: `Km inicial${suffix}`, value: item?.compositiongarrison_initialmileage},
            {label: `Km final${suffix}`, value: item?.compositiongarrison_finalmileage},
            {label: `Contingentes${suffix}`, value: integrants}
        ].filter(row => hasValue(row.value));
    });
};

export const parseAuditJson = (value) => JSON.parse(value ?? "{}");

export const isIgnoredInlineField = (key) => IGNORED_INLINE_FIELDS.includes(key);

export const isAttachmentField = (key) => key === ATTACHMENT_FIELD;

export const isGarrisonFiscalizationField = (key) => key === GARRISON_FISCALIZATION_FIELD;

export const buildAttachmentRows = (value) => {
    let attachments = [];

    if (!value.old && !value.new) {
        attachments = Object.values(value).map(item => ({
            old: item?.old || null,
            new: item?.new || null
        }));
    } else {
        const oldValues = value?.old ? Object.values(value.old) : [];
        const newValues = value?.new ? Object.values(value.new) : [];
        const max = Math.max(oldValues.length, newValues.length);

        for (let i = 0; i < max; i++) {
            attachments.push({
                old: oldValues[i] ?? null,
                new: newValues[i] ?? null
            });
        }
    }

    return attachments.filter(attachment => attachment.old || attachment.new);
};

export const buildGarrisonFiscalizationRows = (garrison) => {
    if (!garrison || typeof garrison !== "object") {
        const value = ReportUtils.formatObjectString(garrison);
        return hasValue(value) ? [{label: "Valor", value}] : [];
    }

    const compositionRows = buildCompositionRows(garrison.garrison_composition);

    return [
        {label: "ID", value: garrison.garrison_id},
        {label: "Nome", value: garrison.garrison_name},
        {label: "Equipe", value: garrison.garrison_team},
        {label: "Local", value: garrison.garrison_place},
        {label: "Início", value: garrison.garrison_start ? ReportUtils.formatObjectString(garrison.garrison_start) : null},
        {label: "Status", value: formatGarrisonStatus(garrison.garrison_status)},
        {label: "Responsável", value: garrison.garrison_leaderid},
        {label: "Encerrada", value: formatBoolean(garrison.garrison_finalized)},
        {label: "Login via app", value: formatBoolean(garrison.garrison_has_mobile)},
        ...compositionRows,
        {label: "Função", value: garrison.garrison_intendedfunction ? translate(garrison.garrison_intendedfunction) : null},
        {label: "Cadastrado via app", value: formatBoolean(garrison.garrison_created_by_mobile)}
    ].filter(row => hasValue(row.value));
};